import ApiClient from '../../services/apiClient';
import { LookupDataEnums } from '../../utilities/Constants';
import { useQuery } from 'react-query';

const _apiClient = new ApiClient();

export const useGetNotePurposeTypes = () => {
    return useQuery({
        queryKey: ['get-note-purposes'],
        queryFn: async () => {
            const response = await _apiClient.getLookupData(LookupDataEnums.NotePurposeTypes);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve note purpose types.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        staleTime: Infinity,
        cacheTime: Infinity,
    });
};
